import type { Common } from '@libs/domain';
import { MstListSearch, MstListSearchRaw } from '@libs/templates/mst';

class LocationMstListSearch extends MstListSearch implements Pick<Common['schema'], 'address'> {
  private constructor(
    mstListSearch: MstListSearch,
    readonly address: string,
  ) {
    super(
      mstListSearch.codeRange,
      mstListSearch.name,
      mstListSearch.mstSpareName01Condition,
      mstListSearch.mstSpareName02Condition,
      mstListSearch.validityStartDateCondition,
      mstListSearch.validityEndDateCondition,
      mstListSearch.mstNoteCondition,
    );
  }

  static init() {
    return new LocationMstListSearch(MstListSearch.baseInit(), '');
  }
}

class LocationMstListSearchRaw extends MstListSearchRaw implements Pick<Common['record'], 'address'> {
  private constructor(
    mstListSearchRaw: MstListSearchRaw,
    readonly address: string,
  ) {
    super(
      mstListSearchRaw.codeRange,
      mstListSearchRaw.isCodeRangeExcluded,
      mstListSearchRaw.name,
      mstListSearchRaw.mstSpareName01,
      mstListSearchRaw.isMstSpareName01BlankOnly,
      mstListSearchRaw.mstSpareName02,
      mstListSearchRaw.isMstSpareName02BlankOnly,
      mstListSearchRaw.validityStartDateFrom,
      mstListSearchRaw.validityStartDateTo,
      mstListSearchRaw.validityEndDateFrom,
      mstListSearchRaw.validityEndDateTo,
      mstListSearchRaw.mstNote,
      mstListSearchRaw.isMstNoteBlankOnly,
    );
  }

  static fromModel(model: LocationMstListSearch) {
    return new LocationMstListSearchRaw(MstListSearchRaw.baseFromModel(model), model.address);
  }
}

export { LocationMstListSearch, LocationMstListSearchRaw };
